import { FeatureAppConfig } from '../types/service-configs';
import { ModelsCarouselIntegratorOptions } from './create-options-from-query-params';

export const createModelsCarouselFaConfig = ({ faServicesUrl, mode }: ModelsCarouselIntegratorOptions): FeatureAppConfig & any => {
  return {
    faHostServerUrl: '',
    faServicesUrl,
    formConfiguration: {
      featureAppSize: 'grid000',
      successMessageContent: {
        headerLabel: 'Thank you for contacting us from Integrator!',
        description:
          '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need. FROM INTEGRATOR</p>',
        buttonCtaLabel: 'Okay from Integrator',
      },
      failedMessageContent: {
        headerLabel: 'Ops Integrator!',
        description: '<p>Ops message from Integrator</p>',
        buttonCtaLabel: 'Back $$formName$$ from Integrator',
      },
    },
    mode, // standalone
    scrollTopOffset: 24, // static padding of the container in integrator.tsx
  }
}